import { styled as n, Box as o } from "@mui/material";
import x from "../../components/share/next/Image.js";
import { useState as d, useEffect as f } from "react";
import { jsxs as c, jsx as e } from "react/jsx-runtime";
const w = n(o)`
  ${(t) => t.show ? `
      transition: transform 0.4s ease-in-out;
      transform: none;
      background: #151615;
      position: fixed;
      z-index: 5;
      display: flex;
      width: 100%;
      height: 60px;
      justify-content: right;
      @media only screen and (max-width: 768px) {
        height: 120px;
      }
    ` : `
      transition: transform 0.4s ease-in-out;
      transform: translate3d(0, -100%, 0);
      background: #151615;
      position: fixed;
      z-index: 5;
      display: flex;
      width: 100%;
      height: 60px;
      justify-content: right;
      @media only screen and (max-width: 768px) {
        height: 120px;
      }
    `}
`, h = n(o)`
  padding-left: 24px;
  padding-top: 14px;
  padding-bottom: 14px;
  width: 150px;
  min-width: 100px;
  @media only screen and (max-width: 768px) {
    width: 250px;
  }
`, m = n(o)`
  flex-grow: 1;
`, b = ({
  children: t,
  logo: a
}) => {
  const [l, i] = d(!0), [r, p] = d(0), s = () => {
    typeof window < "u" && (window.scrollY >= r && window.scrollY > 0 ? i(!1) : i(!0), p(window.scrollY));
  };
  return f(() => {
    if (typeof window < "u")
      return window.addEventListener("scroll", s), () => {
        window.removeEventListener("scroll", s);
      };
  }, [r]), /* @__PURE__ */ c(w, {
    show: l,
    children: [/* @__PURE__ */ e(h, {
      children: /* @__PURE__ */ e(x, {
        src: a
      })
    }), /* @__PURE__ */ e(m, {
      children: t
    })]
  });
};
export {
  b as default
};
//# sourceMappingURL=Header.js.map
